// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Content__Wrapper_3p7Ep","Block":"Content__Block_dh4vY","ColLeft":"Content__ColLeft_2KW1E","ColRight":"Content__ColRight_3f4SW d-none d-sm-block"};